<div class="row mb-2">
    <div class="col">
        <div widget class="card border-0 box-shadow">
            <div class="card-body  widget-body pb-0 pt-2 mb-4">
                <div class="row mb-2 mt-2">
                    <div class="col">
                        <button type="button" class="btn btn-sm" data-bs-toggle="modal"
                            data-bs-target="#CreateRLmodal" (click)="clearRelations()" *ngIf="fp.relationshiplistcreate">Add
                            Relationship</button>
                    </div>
                    <div class="col text-end">
                        <button type="button" class="btn btn-sm " (click)="Refresh()">
                            <i class="fa fa-repeat"> Refresh </i>
                        </button>
                    </div>
                </div>
<!---------------------------- ejs-grid ======================================-->
                <div class="row mt-3" style="min-height: 500px;">
                    <div class="col">
                        <ejs-grid #gridRL [dataSource]='GridList | async' [allowPaging]='true' [pageSettings]='initialPage'
                        [filterSettings]='filterSettings' [allowFiltering]='true' [allowResizing]='true'
                        (dataStateChange)='dataChangeRL($event)' [showColumnChooser]='true'
                        (actionBegin)="onActionRL($event)" [allowSorting]='true'>
                        <e-columns>
                            <e-column minWidth=100 headerText="Actions" [showInColumnChooser]='false'>
                                <ng-template #template let-data>
                                    <button class="btn btn-edit-table" data-bs-toggle="modal"
                                        data-bs-target="#CreateRLmodal" (click)="getDetails(data)"  *ngIf="fp.relationshiplistupdate"><i
                                            class="fa fa-edit"></i></button>&nbsp;
                                    <button class="btn btn-delete-table" data-bs-toggle="modal"
                                        data-bs-target="#deleteRLmodal" (click)="getDetails(data)"  *ngIf="fp.relationshiplistdelete"><i
                                            class="fa fa-trash"></i></button>
                                </ng-template>
                            </e-column>
                            <e-column minWidth=100 field="relationship_Name" headerText="Relationship Name" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
    
                            <e-column width="50" [showInColumnChooser]='false'>
                                <ng-template #headerTemplate let-data>
                                    <div>
                                        <span id='show' (click)='showRelationColumns()'><i class="fa fa-cog fa-lg"
                                                aria-hidden="true">
                                            </i></span>
                                    </div>
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </ejs-grid>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- ejs-grid -->

<!-- For Create or Update Modal -->
<span id="openRLModal" data-bs-toggle="modal" data-bs-target="#CreateRLmodal"></span>
<div class="modal fade" id="CreateRLmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span
                        *ngIf="saveRLInfo.id == '00000000-0000-0000-0000-000000000000'">
                        Create Relationship</span>
                    <span *ngIf=" saveRLInfo.id !='00000000-0000-0000-0000-000000000000'">Update Relationship</span>
                </h5>
                <button type=" button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true" (click)="clearRelations()"> </span>
                        </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-5">
                        <label>RelationshipName<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <input type="text" class="form-control" [(ngModel)]="saveRLInfo.relationship_Name" />
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn  btn-sm" (click)="SaveOrUpdateRelationshipList();" [disabled]="saveRLInfo.relationship_Name==null ||
                saveRLInfo.relationship_Name==undefined || saveRLInfo.relationship_Name==''"><span
                        *ngIf="saveRLInfo.id == '00000000-0000-0000-0000-000000000000'"> Save &
                        Close</span> <span *ngIf="saveRLInfo.id != '00000000-0000-0000-0000-000000000000'">Update &
                        Close</span> </button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal"
                    (click)="clearRelations()">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- For Delete Modal -->
<span id="closeRLModal" data-bs-target="#deleteRLmodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deleteRLmodal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>

            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteRelationship()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" (click)="clearRelations()"
                    data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>